import { ChangeDetectionStrategy, Component, inject, PLATFORM_ID } from '@angular/core';
import { Store } from '@ngrx/store';
import { getNewsPage, getSelectedNews } from '../../store';
import { StripEmbedPipe, getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { ResizeHtmlImagesPipe, ImageComponent } from '@teamfoster/sdk/image';
import { SafePipe } from '@teamfoster/sdk/text-utility';
import { HeaderComponent } from 'src/app/standalone/components/header/header.component';
import { DatePipe, NgOptimizedImage } from '@angular/common';
import { isThisYear } from 'date-fns';
import { NewsDatePipe } from '../../pipes/news-date.pipe';
import { DynamicHooksModule } from 'ngx-dynamic-hooks';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { Router, RouterLink } from '@angular/router';
import { IconComponent } from '@teamfoster/sdk/icon';
import { isPlatformBrowser, JsonPipe, SlicePipe, Location } from '@angular/common';

@Component({
  selector: 'app-news-detail',
  imports: [
    ResizeHtmlImagesPipe,
    StripEmbedPipe,
    ImageComponent,
    NewsDatePipe,
    DynamicHooksModule,
    FromDictionaryPipe,
    RouterLink,
    IconComponent,
    NgOptimizedImage,
  ],
  templateUrl: './news-detail.component.html',
  styleUrl: './news-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsDetailComponent {
  store = inject(Store);
  news$ = this.store.selectSignal(getSelectedNews);
  cookiePreferences = this.store.selectSignal(getCookiePreferences);
  private platformId = inject(PLATFORM_ID);
  private location = inject(Location);
  private router = inject(Router);

  isThisYear(date: string) {
    return isThisYear(date);
  }

  back() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    if ((this.location.getState() as any).navigationId > 1) {
      this.location.back();
      return;
    }
    this.router.navigate(['/nieuws']);
  }
  get showBackButton() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    return (this.location.getState() as any).navigationId > 1;
  }
}
